import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import {
  WorkModelSectionComponent,
  WorkModelSectionTranslations,
  WorkModelSectionTranslationsToken,
  WorkModelSectionViewContext,
} from '@recruitee/locations';

import { RequisitionForm } from '../../../requisitions.types';

const translations: WorkModelSectionTranslations = {
  heading: 'app.requisitions.details_page.work_model.heading',
  subheading: 'app.requisitions.details_page.work_model.subheading',
};

@Component({
  selector: 'rt-requisitions-work-model',
  templateUrl: './requisitions-work-model.component.html',
  styleUrls: ['./requisitions-work-model.component.less'],
  imports: [WorkModelSectionComponent],
  providers: [{ provide: WorkModelSectionTranslationsToken, useValue: translations }],
})
export class RequisitionsWorkModelComponent {
  public readonly WorkModelSectionViewContext = WorkModelSectionViewContext;

  @Input() public isFormEditable: boolean;
  @Input() public form: FormGroup<RequisitionForm>;

  public get workModelControl() {
    return <FormGroup>this.form.get('workModel')!;
  }
}
